import React, { useState, useEffect } from "react";
import { Box, createTheme, Stack, Typography, Grid } from "@mui/material";
import axios from "axios";
import { useStateValue } from "../../../StateProvider";
import Chart from "react-apexcharts";
import { useParams } from "react-router-dom";

import { styled } from "@mui/system";
import { makeStyles } from "@mui/styles";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const TimeBarSpan = styled("span")({
  "&:hover": {
    backgroundColor: "#2d79db22",
    cursor: "pointer",
  },
});

// const useStyles = makeStyles({
//   selectedNB: {
//     backgroundColor: "#2d79db22",
//     // color: "#0aa86c",
//   },
// });
const useStyles = makeStyles((theme) => ({
  rh3: {
    fontFamily: "public sans",
    fontSize: "1rem",
    fontWeight: "300",
    color: "fontPrimaryColor.main",
    xs: {},
  },
  rh6: {
    fontFamily: "public sans",
    fontSize: "0.55rem",
    fontWeight: "600",
    color: "fontSecondaryColor.main",
    marginBottom: "5px",
  },
  selectedSpan: {
    fontSize: "0.8rem",
    fontWeight: "300",
    fontFamily: "primaryFont.main",
    color: "fontPrimaryColor.main",
    padding: "6px 9px",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    height: "30px",
    backgroundColor: "#2d79db22",
  },
  unSelectedSpan: {
    fontSize: "0.8rem",
    fontWeight: "300",
    color: "fontPrimaryColor.main",
    fontFamily: "primaryFont.main",
    padding: "6px 9px",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    height: "30px",
  },
}));

const PriceDetailsContainer = ({ stockData, stockStat, mode }) => {
  const classes = useStyles();
  const params = useParams();
  const [{ token }] = useStateValue();
  const [priceTime, setPriceTime] = useState("1m");
  const [chartSeriesData, setChartSeriesData] = useState([{ data: [] }]);
  const [oneD, setOneD] = useState([]);
  const [oneM, setOneM] = useState([]);
  const [threeM, setThreeM] = useState([]);
  const [sixM, setSixM] = useState([]);
  const [oneY, setOneY] = useState([]);
  const [twoY, setTwoY] = useState([]);
  const [fiveY, setFiveY] = useState([]);
  const [dat, setData] = useState([]);
  const [change, setChange] = useState(null);
  const round = (n) => {
    return n ? +n.toFixed(2) : null;
  };
  useEffect(() => {
    console.log("useEffect");

    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/intraday-prices?chartInterval=15&&token=${token}`
      )
      .then((res) => {
        setOneD(res?.data);
      });
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/1m?token=${token}`
      )
      .then((res) => {
        setOneM(res?.data);
        // console.log("one month data", res?.data);
      });
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/3m?token=${token}`
      )
      .then((res) => {
        setThreeM(res?.data);
        // console.log("three month data", res?.data);
      });
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/6m?token=${token}`
      )
      .then((res) => setSixM(res?.data));
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/1y?token=${token}`
      )
      .then((res) => setOneY(res?.data));
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/2y?token=${token}`
      )
      .then((res) => setTwoY(res?.data));
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/5y?token=${token}`
      )
      .then((res) => {
        setFiveY(res?.data);
        setData(res?.data);
      });
    // console.log("stock data", stockData);
    // console.log("stock state", stockStat);
  }, []);
  useEffect(() => {
    let response =
      priceTime == "1d"
        ? oneD
        : priceTime == "1m"
        ? oneM
        : priceTime == "3m"
        ? threeM
        : priceTime == "6m"
        ? sixM
        : priceTime == "1y"
        ? oneY
        : priceTime == "2y"
        ? twoY
        : priceTime == "5y"
        ? fiveY
        : "";
    let prices;
    if (priceTime == "1d") {
      console.log("one day response ", response);
      prices = response.map((p, index) => ({
        x: p?.label,
        y: p?.close?.toFixed(2),
        high: p?.high?.toFixed(2),
        low: p?.low?.toFixed(2),
        open: p?.open?.toFixed(2),
        close: p?.close?.toFixed(2),
      }));
    } else {
      console.log("one month response", response);
      prices = response.map((p, index) => ({
        // x: priceTime == "1m" ? p?.priceDate : p?.date,
        x: p?.label,
        // y: [p?.open, p?.high, p?.low, p?.close],
        y: p?.close?.toFixed(2),
        high: p?.high?.toFixed(2),
        low: p?.low?.toFixed(2),
        open: p?.open?.toFixed(2),
        close: p?.close?.toFixed(2),
        volume: p?.volume?.toFixed(2),
        change: p?.changePercent?.toFixed(2),
      }));
    }

    setChartSeriesData([{ name: "prices", data: prices }]);
    /*********** CHANGE */
    // console.log("prices", response);

    // let t = 0;

    // response.map((r, i) => {
    //   t = t + Number(r?.change);
    // });

    // console.log("change", t);
    // setChange(t);

    let s = response[0]?.close;
    let l = response[response?.length - 1]?.close
      ? response[response?.length - 1]?.close
      : response[response?.length - 2]?.close;
    let ch = null;
    if (s < l) {
      ch = ((l - s) / s) * 100;
    } else {
      ch = ((s - l) / l) * 100;
    }
    setChange(s > l ? "-" + round(ch) : "+" + round(ch));
    // console.log("change one day", round(ch), s, l);
    // console.log("change", round(ch));
  }, [priceTime, dat]);

  const handlePriceTimeChange = (event) => {
    setPriceTime(event.target.value);
  };

  /************************** */
  const chart = {
    options: {
      plotOptions: {
        candlestick: {
          colors: {
            upward: "#29d293",
            downward: "#db1010",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      // stroke: {
      //   curve: "smooth",
      //   width: 1.6,
      // },
      chart: {
        type: "candlestick",
        height: 750,
        background: "transparent",
        zoom: {
          enabled: true,
        },
      },
      // colors: ["#2d79db"],
      grid: {
        show: true,
        borderColor: "#d9d9d933",
        row: {},
        xaxis: {
          lines: {
            show: false,
          },
          position: "top",
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      theme: {
        mode: mode,
        // palette: "palette5",
        monochrome: {
          enabled: true,
          color: "#29d293",
          shadeTo: "light",
          shadeIntensity: 0.55,
        },
      },
      stroke: {
        curve: "smooth",
        width: 0,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0,
          opacityFrom: 1,
          opacityTo: 0.6,
        },
      },

      title: {
        text: "",
        align: "left",
      },
      xaxis: {
        tickAmount: window?.screen?.width > 768 ? 15 : 10,
        type: "time",
        // labels: {
        //   show: true,
        // },
        labels: {
          show: true,

          hideOverlappingLabels: true,

          maxHeight: 180,
          style: {
            colors: [],
            fontSize: "11px",
            fontFamily: "public sans, Arial, sans-serif",
            fontWeight: 400,
            cssClass: "apexcharts-xaxis-label",
            marginTop: "10px",
            marginTop: 20,
            paddingTop: 10,
          },
        },

        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
      },
      yaxis: {
        tickAmount: 10,
        tooltip: {
          enabled: true,
        },
        // labels: {
        //   show: true,
        // },
        labels: {
          show: true,
          align: "right",
          minWidth: 0,
          maxWidth: 160,
          style: {
            colors: [],
            fontSize: "11px",
            fontFamily: "public sans, sans-serif",
            fontWeight: 400,
            cssClass: "apexcharts-yaxis-label",
          },

          formatter: (value) => {
            return value?.toFixed(2);
          },
        },
        lines: {
          show: true,
        },
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

          return (
            "<div style='padding:8px;background:#0007;color:#fff;display:flex;flex-direction:column;gap:3px;'>" +
            "<div style='font-size:10px;'><b> " +
            data.x +
            "</b></div>" +
            "<div style='font-size:10px;'><b>High</b>: " +
            data.high +
            "</div>" +
            "<div style='font-size:10px;'><b>Low</b>: " +
            data.low +
            "</div>" +
            "<div style='font-size:10px;'><b>Open</b>: " +
            data.open +
            "</div>" +
            "<div style='font-size:10px;'><b>Close</b>: " +
            data.close +
            "</div>"
          );
        },
      },
    },
    options2: {
      plotOptions: {
        candlestick: {
          colors: {
            upward: "#22b55a",
            downward: "#db1010",
          },
        },
      },

      chart: {
        type: "candlestick",
        height: 750,
        background: "transparent",
        zoom: {
          enabled: true,
        },
      },
      grid: {
        show: true,
        borderColor: "#d9d9d933",
        row: {},
        xaxis: {
          lines: {
            show: false,
          },
          position: "top",
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      theme: {
        mode: mode,
        // palette: "palette5",
        monochrome: {
          enabled: true,
          color: "#29d293",
          shadeTo: "light",
          shadeIntensity: 0.55,
        },
      },
      stroke: {
        curve: "smooth",
        width: 0,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0,
          opacityFrom: 1,
          opacityTo: 0.5,
        },
      },
      dataLabels: {
        enabled: false,
      },

      title: {
        text: "",
        align: "left",
      },
      xaxis: {
        type: "category",
        tickAmount: window?.screen?.width > 768 ? 30 : 10,
        // labels: {
        //   show: true,
        // },
        labels: {
          show: true,

          hideOverlappingLabels: true,

          maxHeight: 180,
          style: {
            colors: [],
            fontSize: "11px",
            fontFamily: "public sans, Arial, sans-serif",
            fontWeight: 400,
            cssClass: "apexcharts-xaxis-label",
            marginTop: "10px",
            marginTop: 20,
            paddingTop: 10,
          },
        },

        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
      },
      yaxis: {
        tickAmount: 10,
        tooltip: {
          enabled: true,
        },
        // labels: {
        //   show: true,
        // },
        labels: {
          show: true,
          align: "right",
          minWidth: 0,
          maxWidth: 160,
          style: {
            colors: [],
            fontSize: "11px",
            fontFamily: "public sans, sans-serif",
            fontWeight: 400,
            cssClass: "apexcharts-yaxis-label",
          },

          formatter: (value) => {
            return value?.toFixed(2);
          },
        },
        lines: {
          show: true,
        },
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

          return (
            "<div style='padding:10px;background:#0007;color:#fff; display:flex;flex-direction:column;gap:3px;'>" +
            "<div style='font-size:10px;'><b> " +
            data.x +
            "</b></div>" +
            "<div style='font-size:10px;'><b>High</b>: " +
            data.high +
            "</div>" +
            "<div style='font-size:10px;'><b>Low</b>: " +
            data.low +
            "</div>" +
            "<div style='font-size:10px;'><b>Open</b>: " +
            data.open +
            "</div>" +
            "<div style='font-size:10px;'><b>Close</b>: " +
            data.close +
            "</div>" +
            "<div style='font-size:10px;'><b>Volume</b>: " +
            numFormatter(data.volume) +
            "</div>" +
            "<div style='font-size:10px;'><b>Change (%)</b>: " +
            data.change +
            "</div>" +
            "</div>"
          );
        },
      },
    },
  };

  return (
    <Box className="price__details__container" bgcolor={"bgPrimary.main"}>
      {/* <div className="price__timebar__wrapper">
        <div className="price__timebar">
          <span onClick={() => setPriceTime("1d")}>1D</span>
          <span onClick={() => setPriceTime("1m")}>1M</span>
          <span onClick={() => setPriceTime("3m")}>3M</span>
          <span onClick={() => setPriceTime("6m")}>6M</span>
          <span onClick={() => setPriceTime("1y")}>1Y</span>
          <span onClick={() => setPriceTime("2y")}>2Y</span>
          <span onClick={() => setPriceTime("5y")}>5Y</span>
        </div>
      </div> */}

      <Box
        direction="row"
        sx={{
          display: "flex",
          width: "98%",
          alignItems: "center",
          flexDirection: "column-reverse",
          gap: "30px",
        }}
      >
        {" "}
        <Box>
          <Typography
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontSecondaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            Price Change (%)
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "1.5rem",
            }}
          >
            {change}%
          </Typography>
        </Box>
        <Stack
          direction="row"
          bgcolor={"bgSecondary.main"}
          // sx={{ display: "flex" }}
          sx={{
            padding: "5px 10px",
            alignItems: "center",
            borderRadius: "8px",
            marginTop: { xs: "30px", sm: "0" },
          }}
          color="black"
          spacing={1}
        >
          <TimeBarSpan
            onClick={() => setPriceTime("1d")}
            className={
              priceTime == "1d" ? classes.selectedSpan : classes.unSelectedSpan
            }
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            1d
          </TimeBarSpan>
          <TimeBarSpan
            onClick={() => setPriceTime("1m")}
            className={
              priceTime == "1m" ? classes.selectedSpan : classes.unSelectedSpan
            }
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            1m
          </TimeBarSpan>
          <TimeBarSpan
            onClick={() => setPriceTime("3m")}
            className={
              priceTime == "3m" ? classes.selectedSpan : classes.unSelectedSpan
            }
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            3m
          </TimeBarSpan>
          <TimeBarSpan
            onClick={() => setPriceTime("6m")}
            className={
              priceTime == "6m" ? classes.selectedSpan : classes.unSelectedSpan
            }
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            6m
          </TimeBarSpan>
          <TimeBarSpan
            onClick={() => setPriceTime("1y")}
            className={
              priceTime == "1y" ? classes.selectedSpan : classes.unSelectedSpan
            }
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            1y
          </TimeBarSpan>
          <TimeBarSpan
            onClick={() => setPriceTime("2y")}
            className={
              priceTime == "2y" ? classes.selectedSpan : classes.unSelectedSpan
            }
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            2y
          </TimeBarSpan>
          <TimeBarSpan
            onClick={() => setPriceTime("5y")}
            className={
              priceTime == "5y" ? classes.selectedSpan : classes.unSelectedSpan
            }
            sx={{
              fontFamily: "public sans",
              fontWeight: "400",
              color: "fontPrimaryColor.main",
              fontSize: "0.8rem",
            }}
          >
            5y
          </TimeBarSpan>
        </Stack>
        {/* <Select
          value={priceTime}
          onChange={handlePriceTimeChange}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          sx={{ fontFamily: "public sans", fontWeight: "300" }}
          className={classes.select}
        >
          
          <MenuItem value={"1d"}>one day</MenuItem>
          <MenuItem value={"1m"} selected>
            one month
          </MenuItem>
          <MenuItem value={"3m"}>three month</MenuItem>
          <MenuItem value={"6m"}>six month</MenuItem>
          <MenuItem value={"1y"}>one year</MenuItem>
          <MenuItem value={"2y"}>two year</MenuItem>
          <MenuItem value={"5y"}>five year</MenuItem>
        </Select> */}
      </Box>

      <div className="price__charts__wrapper">
        <Chart
          options={priceTime == "1d" ? chart?.options : chart?.options2}
          series={chartSeriesData}
          type="area"
          height={window?.screen?.width > 600 ? "340%" : "250%"}
          width="98%"
        />
      </div>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-around",
          margin: "30px 0 50px 0",
          gap: "40px",
          width: { xs: "90%", md: "max-content" },
        }}
      >
        <Box>
          <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
            Volume
          </Box>
          <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
            {stockData?.latestVolume}
          </Box>
        </Box>
        <Box>
          <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
            AVG 10 VOLUME
          </Box>
          <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
            {stockStat?.avg10Volume}
          </Box>
        </Box>
        <Box>
          <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
            SHARES OUTSTANDING
          </Box>
          <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
            {stockStat?.sharesOutstanding}
          </Box>
        </Box>
        <Box>
          <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
            BETA
          </Box>
          <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
            {round(stockStat?.beta)}
          </Box>
        </Box>
        <Box>
          <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
            DIVIDEND & YIELD
          </Box>
          <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
            {stockStat?.dividendYield?.toFixed(9)}
          </Box>
        </Box>
        <Box>
          <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
            EX-DIVIDEND DATE
          </Box>
          <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
            {stockStat?.exDividendDate ? stockStat?.exDividendDate : "N/A"}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PriceDetailsContainer;
function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900 && num > 0) {
    return num; // if value < 1000, nothing to do
  } else if (num < -999 && num > -1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num < -1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num < -100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num < -1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num > -900) {
    return num; // if value < 1000, nothing to do
  }
}

// import React, { useState, useEffect } from "react";
// import { Box, createTheme, Stack, Typography, Grid } from "@mui/material";
// import axios from "axios";
// import { useStateValue } from "../../../StateProvider";
// import Chart from "react-apexcharts";
// import { useParams } from "react-router-dom";

// import { styled } from "@mui/system";
// import { makeStyles } from "@mui/styles";
// import MenuItem from "@mui/material/MenuItem";
// import Select, { SelectChangeEvent } from "@mui/material/Select";

// const TimeBarSpan = styled("span")({
//   "&:hover": {
//     backgroundColor: "#2d79db22",
//     cursor: "pointer",
//   },
// });

// // const useStyles = makeStyles({
// //   selectedNB: {
// //     backgroundColor: "#2d79db22",
// //     // color: "#0aa86c",
// //   },
// // });
// const useStyles = makeStyles((theme) => ({
//   rh3: {
//     fontFamily: "public sans",
//     fontSize: "1rem",
//     fontWeight: "300",
//     color: "fontPrimaryColor.main",
//     xs: {},
//   },
//   rh6: {
//     fontFamily: "public sans",
//     fontSize: "0.55rem",
//     fontWeight: "600",
//     color: "fontSecondaryColor.main",
//     marginBottom: "5px",
//   },
//   selectedSpan: {
//     fontSize: "0.8rem",
//     fontWeight: "300",
//     fontFamily: "primaryFont.main",
//     padding: "6px 9px",
//     borderRadius: "8px",
//     transition: "all 0.3s ease",
//     height: "30px",
//     backgroundColor: "#2d79db22",
//   },
//   unSelectedSpan: {
//     fontSize: "0.8rem",
//     fontWeight: "300",
//     fontFamily: "primaryFont.main",
//     padding: "6px 9px",
//     borderRadius: "8px",
//     transition: "all 0.3s ease",
//     height: "30px",
//   },
// }));

// const PriceDetailsContainer = ({ stockData, stockStat, mode }) => {
//   const classes = useStyles();
//   const params = useParams();
//   const [{ token }] = useStateValue();
//   const [priceTime, setPriceTime] = useState("1m");
//   const [chartSeriesData, setChartSeriesData] = useState([{ data: [] }]);
//   const [oneD, setOneD] = useState([]);
//   const [oneM, setOneM] = useState([]);
//   const [threeM, setThreeM] = useState([]);
//   const [sixM, setSixM] = useState([]);
//   const [oneY, setOneY] = useState([]);
//   const [twoY, setTwoY] = useState([]);
//   const [fiveY, setFiveY] = useState([]);
//   const [dat, setData] = useState([]);
//   const [change, setChange] = useState(null);
//   const round = (n) => {
//     return n ? +n.toFixed(2) : null;
//   };
//   useEffect(() => {
//     console.log("useEffect");

//     axios
//       .get(
//         `https://cloud.iexapis.com/stable/stock/${params?.symbol}/intraday-prices?chartInterval=15&&token=${token}`
//       )
//       .then((res) => {
//         setOneD(res?.data);
//       });
//     axios
//       .get(
//         `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/1m?token=${token}`
//       )
//       .then((res) => setOneM(res?.data));
//     axios
//       .get(
//         `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/3m?token=${token}`
//       )
//       .then((res) => setThreeM(res?.data));
//     axios
//       .get(
//         `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/6m?token=${token}`
//       )
//       .then((res) => setSixM(res?.data));
//     axios
//       .get(
//         `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/1y?token=${token}`
//       )
//       .then((res) => setOneY(res?.data));
//     axios
//       .get(
//         `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/2y?token=${token}`
//       )
//       .then((res) => setTwoY(res?.data));
//     axios
//       .get(
//         `https://cloud.iexapis.com/stable/stock/${params?.symbol}/chart/5y?token=${token}`
//       )
//       .then((res) => {
//         setFiveY(res?.data);
//         setData(res?.data);
//       });
//     console.log("stock data", stockData);
//     console.log("stock state", stockStat);
//   }, []);
//   useEffect(() => {
//     let response =
//       priceTime == "1d"
//         ? oneD
//         : priceTime == "1m"
//         ? oneM
//         : priceTime == "3m"
//         ? threeM
//         : priceTime == "6m"
//         ? sixM
//         : priceTime == "1y"
//         ? oneY
//         : priceTime == "2y"
//         ? twoY
//         : priceTime == "5y"
//         ? fiveY
//         : "";
//     let prices;
//     if (priceTime == "1d") {
//       prices = response.map((p, index) => ({
//         x: p?.label,
//         y: [p?.marketOpen, p?.marketHigh, p?.marketLow, p?.marketClose],
//       }));
//     } else {
//       prices = response.map((p, index) => ({
//         x: priceTime == "1m" ? p?.priceDate : p?.date,
//         y: [p?.open, p?.high, p?.low, p?.close],
//       }));
//     }

//     setChartSeriesData([{ data: prices }]);
//     /*********** CHANGE */
//     // console.log("prices", response);

//     // let t = 0;

//     // response.map((r, i) => {
//     //   t = t + Number(r?.change);
//     // });

//     // console.log("change", t);
//     // setChange(t);

//     let s = response[0]?.close;
//     let l = response[response?.length - 1]?.close
//       ? response[response?.length - 1]?.close
//       : response[response?.length - 2]?.close;
//     let ch = null;
//     if (s < l) {
//       ch = ((l - s) / s) * 100;
//     } else {
//       ch = ((s - l) / l) * 100;
//     }
//     setChange(s > l ? "-" + round(ch) : "+" + round(ch));
//     // console.log("change one day", round(ch), s, l);
//     // console.log("change", round(ch));
//   }, [priceTime, dat]);

//   const handlePriceTimeChange = (event) => {
//     setPriceTime(event.target.value);
//   };

//   /************************** */
//   const chart = {
//     options: {
//       plotOptions: {
//         candlestick: {
//           colors: {
//             upward: "#22b55a",
//             downward: "#db1010",
//           },
//         },
//       },
//       chart: {
//         type: "candlestick",
//         height: 750,
//         background: "transparent",
//         zoom: {
//           enabled: true,
//         },
//       },
//       grid: {
//         show: true,
//         borderColor: "#d9d9d933",
//         row: {},
//         xaxis: {
//           lines: {
//             show: false,
//           },
//           position: "top",
//         },
//         yaxis: {
//           lines: {
//             show: true,
//           },
//         },
//       },
//       theme: {
//         mode: mode,
//         palette: "palette5",
//       },

//       title: {
//         text: "",
//         align: "left",
//       },
//       xaxis: {
//         type: "time",
//         labels: {
//           show: true,
//         },

//         axisBorder: {
//           show: true,
//         },
//         axisTicks: {
//           show: true,
//         },
//       },
//       yaxis: {
//         tickAmount: 10,
//         tooltip: {
//           enabled: true,
//         },
//         labels: {
//           show: true,
//         },
//         lines: {
//           show: true,
//         },
//       },
//     },
//     options2: {
//       plotOptions: {
//         candlestick: {
//           colors: {
//             upward: "#22b55a",
//             downward: "#db1010",
//           },
//         },
//       },
//       chart: {
//         type: "candlestick",
//         height: 750,
//         background: "transparent",
//         zoom: {
//           enabled: true,
//         },
//       },
//       grid: {
//         show: true,
//         borderColor: "#d9d9d933",
//         row: {},
//         xaxis: {
//           lines: {
//             show: false,
//           },
//           position: "top",
//         },
//         yaxis: {
//           lines: {
//             show: true,
//           },
//         },
//       },
//       theme: {
//         mode: mode,
//         palette: "palette5",
//       },

//       title: {
//         text: "",
//         align: "left",
//       },
//       xaxis: {
//         type: "datetime",
//         labels: {
//           show: true,
//         },

//         axisBorder: {
//           show: true,
//         },
//         axisTicks: {
//           show: true,
//         },
//       },
//       yaxis: {
//         tickAmount: 10,
//         tooltip: {
//           enabled: true,
//         },
//         labels: {
//           show: true,
//         },
//         lines: {
//           show: true,
//         },
//       },
//     },
//   };
//   return (
//     <Box className="price__details__container" bgcolor={"bgPrimary.main"}>
//       {/* <div className="price__timebar__wrapper">
//         <div className="price__timebar">
//           <span onClick={() => setPriceTime("1d")}>1D</span>
//           <span onClick={() => setPriceTime("1m")}>1M</span>
//           <span onClick={() => setPriceTime("3m")}>3M</span>
//           <span onClick={() => setPriceTime("6m")}>6M</span>
//           <span onClick={() => setPriceTime("1y")}>1Y</span>
//           <span onClick={() => setPriceTime("2y")}>2Y</span>
//           <span onClick={() => setPriceTime("5y")}>5Y</span>
//         </div>
//       </div> */}

//       <Box
//         direction="row"
//         sx={{
//           display: "flex",
//           width: "98%",
//           alignItems: "center",
//           flexDirection: "column-reverse",
//           gap: "30px",
//         }}
//       >
//         {" "}
//         <Box>
//           <Typography
//             sx={{
//               fontFamily: "public sans",
//               fontWeight: "400",
//               color: "fontSecondaryColor.main",
//               fontSize: "0.8rem",
//             }}
//           >
//             Price Change (%)
//           </Typography>

//           <Typography
//             variant="h5"
//             sx={{
//               fontFamily: "public sans",
//               fontWeight: "400",
//               color: "fontPrimaryColor.main",
//               fontSize: "1.5rem",
//             }}
//           >
//             {change}%
//           </Typography>
//         </Box>
//         <Stack
//           direction="row"
//           bgcolor={"bgSecondary.main"}
//           // sx={{ display: "flex" }}
//           sx={{
//             padding: "5px 10px",
//             alignItems: "center",
//             borderRadius: "8px",
//           }}
//           color="black"
//           spacing={1}
//         >
//           <TimeBarSpan
//             onClick={() => setPriceTime("1d")}
//             className={
//               priceTime == "1d" ? classes.selectedSpan : classes.unSelectedSpan
//             }
//           >
//             1d
//           </TimeBarSpan>
//           <TimeBarSpan
//             onClick={() => setPriceTime("1m")}
//             className={
//               priceTime == "1m" ? classes.selectedSpan : classes.unSelectedSpan
//             }
//           >
//             1m
//           </TimeBarSpan>
//           <TimeBarSpan
//             onClick={() => setPriceTime("3m")}
//             className={
//               priceTime == "3m" ? classes.selectedSpan : classes.unSelectedSpan
//             }
//           >
//             3m
//           </TimeBarSpan>
//           <TimeBarSpan
//             onClick={() => setPriceTime("6m")}
//             className={
//               priceTime == "6m" ? classes.selectedSpan : classes.unSelectedSpan
//             }
//           >
//             6m
//           </TimeBarSpan>
//           <TimeBarSpan
//             onClick={() => setPriceTime("1y")}
//             className={
//               priceTime == "1y" ? classes.selectedSpan : classes.unSelectedSpan
//             }
//           >
//             1y
//           </TimeBarSpan>
//           <TimeBarSpan
//             onClick={() => setPriceTime("2y")}
//             className={
//               priceTime == "2y" ? classes.selectedSpan : classes.unSelectedSpan
//             }
//           >
//             2y
//           </TimeBarSpan>
//           <TimeBarSpan
//             onClick={() => setPriceTime("5y")}
//             className={
//               priceTime == "5y" ? classes.selectedSpan : classes.unSelectedSpan
//             }
//           >
//             5y
//           </TimeBarSpan>
//         </Stack>
//         {/* <Select
//           value={priceTime}
//           onChange={handlePriceTimeChange}
//           displayEmpty
//           inputProps={{ "aria-label": "Without label" }}
//           sx={{ fontFamily: "public sans", fontWeight: "300" }}
//           className={classes.select}
//         >

//           <MenuItem value={"1d"}>one day</MenuItem>
//           <MenuItem value={"1m"} selected>
//             one month
//           </MenuItem>
//           <MenuItem value={"3m"}>three month</MenuItem>
//           <MenuItem value={"6m"}>six month</MenuItem>
//           <MenuItem value={"1y"}>one year</MenuItem>
//           <MenuItem value={"2y"}>two year</MenuItem>
//           <MenuItem value={"5y"}>five year</MenuItem>
//         </Select> */}
//       </Box>

//       <div className="price__charts__wrapper">
//         <Chart
//           options={priceTime == "1d" ? chart?.options : chart?.options2}
//           series={chartSeriesData}
//           type="candlestick"
//           height="340%"
//           width="98%"
//         />
//       </div>
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", md: "row" },
//           justifyContent: "space-around",
//           margin: "30px 0 50px 0",
//           gap: "40px",
//           width: { xs: "90%", md: "max-content" },
//         }}
//       >
//         <Box>
//           <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
//             Volume
//           </Box>
//           <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
//             {stockData?.latestVolume}
//           </Box>
//         </Box>
//         <Box>
//           <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
//             AVG 10 VOLUME
//           </Box>
//           <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
//             {stockStat?.avg10Volume}
//           </Box>
//         </Box>
//         <Box>
//           <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
//             SHARES OUTSTANDING
//           </Box>
//           <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
//             {stockStat?.sharesOutstanding}
//           </Box>
//         </Box>
//         <Box>
//           <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
//             BETA
//           </Box>
//           <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
//             {round(stockStat?.beta)}
//           </Box>
//         </Box>
//         <Box>
//           <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
//             DIVIDEND & YIELD
//           </Box>
//           <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
//             {stockStat?.dividendYield?.toFixed(9)}
//           </Box>
//         </Box>
//         <Box>
//           <Box className={classes.rh6} sx={{ color: "fontPrimaryColor.main" }}>
//             EX-DIVIDEND DATE
//           </Box>
//           <Box className={classes.rh3} sx={{ color: "fontPrimaryColor.main" }}>
//             {stockStat?.exDividendDate ? stockStat?.exDividendDate : "N/A"}
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default PriceDetailsContainer;
